import { generateClient } from 'aws-amplify/api';
import { deleteDailyReport } from "../graphql/mutations";

const client = generateClient();

export default async ({ id }) => {
    const {
        data: { deleteDailyReport: deletedDailyReport },
    } = await client.graphql({
        query: deleteDailyReport,
        variables: {
            input: {
                id,
            },
        },
    });
    return deletedDailyReport;
};